const material = {
  // ==================== MATERIAL QUICK ENTRY ====================
  'material.title': 'Material Quick Entry',
  'material.subtitle': 'Quickly capture material master data and transmit it to SAP',
  'material.inDevelopmentDesc': 'Material Quick Entry provides a heavily simplified form with reduced mandatory fields to create new material masters quickly.',

  // --- Tabs / Navigation ---
  'material.tabCapture': 'Capture',
  'material.tabList': 'Overview',
  'material.tabConfig': 'Field configuration',
  'material.newMaterial': 'New material',

  // --- Org bar / header ---
  'material.matnr': 'Material number',
  'material.matnrAuto': 'empty = internal assignment',
  'material.werks': 'Plant',
  'material.vkorg': 'Sales org.',
  'material.vtweg': 'Distr. channel',
  'material.fromTemplate': 'From template',

  // --- Fields (general) ---
  'material.selectPlaceholder': '– please select –',
  'material.yes': 'Yes',
  'material.descEn': 'Description (EN)',
  'material.addEn': 'Add English description',
  'material.hideEn': 'Hide English description',
  'material.noFieldsConfigured': 'No fields are enabled. Please enable fields in the field configuration.',

  // --- Capture actions ---
  'material.saveDraft': 'Save as draft',
  'material.create': 'Create',
  'material.update': 'Update',
  'material.savedReady': 'Material created.',
  'material.savedDraft': 'Draft saved.',
  'material.missingRequired': 'Please fill in all mandatory fields (*).',
  'material.saveError': 'Saving failed.',
  'material.fillProgress': '{filled} / {total} fields filled',
  'material.collapseAll': 'Collapse all',
  'material.expandAll': 'Expand all',
  'material.texts': 'Texts',
  'material.addText': 'Add text',
  'material.textPlaceholder': 'Enter text…',
  'material.fillCol': 'Progress',

  // --- Duplicate check ---
  'material.dupSetting': 'Duplicate check on create',
  'material.dupSettingHint': 'Optional: checks for a similar material before creating (avoids duplicates).',
  'material.dupTitle': 'Possible duplicate found',
  'material.dupSubtitle': 'Similar materials exist. Please check whether this is a duplicate.',
  'material.dupSourceMaterial': 'Capture',
  'material.dupSourceCatalog': 'Catalog',
  'material.dupSourceSap': 'SAP material master',
  'material.dupReason_ean': 'same EAN',
  'material.dupReason_bismt': 'same material number',
  'material.dupReason_desc': 'similar description',
  'material.dupReason_matkl': 'same material group',
  'material.dupMatch': 'Match',
  'material.dupCancel': 'Cancel',
  'material.dupProceed': 'Create anyway',
  'material.dupProceedUpdate': 'Save anyway',
  'material.textLang': 'Text language',

  // --- Field-config presets ---
  'material.presets': 'Presets',
  'material.presetChoose': '– choose preset –',
  'material.presetLoad': 'Load',
  'material.presetSaveAs': 'Save as preset',
  'material.presetReset': 'Reset to default',
  'material.presetNamePrompt': 'Name for the configuration:',
  'material.presetSaved': 'Preset saved.',
  'material.presetSaveError': 'Preset could not be saved.',
  'material.presetApplied': 'Preset “{name}” applied (not yet saved).',
  'material.presetConfirmDelete': 'Really delete preset “{name}”?',
  'material.presetDeleted': 'Preset deleted.',
  'material.presetDeleteError': 'Preset could not be deleted.',
  'material.settingsSaved': 'Setting saved.',

  // --- PDF attachments ---
  'material.attachments': 'Attachments (PDF)',
  'material.attAdd': 'Add PDF',
  'material.attDropHint': 'Drag PDFs here or click “Add PDF”',
  'material.attDropHintNew': 'Drag PDFs here — uploaded after you save',
  'material.attDropNow': 'Release to upload',
  'material.attPending': 'uploaded on save',
  'material.attSaveFirst': 'Save the material first, then you can attach PDFs.',
  'material.attEmpty': 'No attachments yet.',
  'material.attOnlyPdf': 'Only PDF files allowed.',
  'material.attUploaded': 'PDF attached.',
  'material.attUploadError': 'Upload failed.',
  'material.attLoadError': 'Attachments could not be loaded.',
  'material.attDownload': 'Open',
  'material.attConfirmDelete': 'Really delete this attachment?',
  'material.attDeleted': 'Attachment deleted.',
  'material.attDeleteError': 'Deletion failed.',

  // --- Field configuration (admin) ---
  'material.configTitle': 'Manage fields',
  'material.activeFields': '{n} of {total} fields active',
  'material.configSave': 'Save configuration',
  'material.configSaved': 'Field configuration saved.',
  'material.configSaveError': 'Configuration could not be saved.',
  'material.configLoadError': 'Field configuration could not be loaded.',
  'material.coreField': 'Core field',
  'material.toggleActive': 'Active',
  'material.toggleRequired': 'Required',
  'material.configSearch': 'Find field (label, SAP field)…',
  'material.allActive': 'All active',
  'material.allRequired': 'All required',
  'material.allSap': 'All SAP',
  'material.allOff': 'All off',
  'material.toggleSap': 'From SAP',
  // --- Load material from SAP ---
  'material.sapLoad': 'Load from SAP',
  'material.sapLoadTitle': 'Load material from SAP',
  'material.sapLoadSubtitle': 'Search the SAP material master and use it as a template.',
  'material.sapSearchPlaceholder': 'Search SAP material master (description, number, EAN)…',
  'material.sapNoResults': 'No SAP materials found.',
  'material.sapNoVisibleFields': 'No fields configured as “visible from SAP”.',
  'material.sapUseAsTemplate': 'Use as template',
  'material.sapSearchError': 'SAP search failed.',
  'material.sapLoadError': 'SAP material could not be loaded.',

  // --- Overview ---
  'material.searchPlaceholder': 'Search (description, number, group)…',
  'material.allStatus': 'All statuses',
  'material.status_draft': 'Draft',
  'material.status_ready': 'Ready',
  'material.status_transferred': 'Transferred',
  'material.description': 'Description',
  'material.mtart': 'Material type',
  'material.matkl': 'Material group',
  'material.statusCol': 'Status',
  'material.actions': 'Actions',
  'material.edit': 'Edit',
  'material.useAsTemplate': 'Use as template',
  'material.transfer': 'Transfer to SAP',
  'material.mirror': 'Mirror into catalog',
  // --- SAP transfer ---
  'material.trfTitle': 'Transfer to SAP',
  'material.trfStubNote': 'This environment does not send to SAP (MATERIAL_SAP_TARGET=mock): the BAPI payload is generated and logged, the status is set to “Transferred”, no SAP material number is assigned.',
  'material.trfConfirm': 'Transfer to SAP',
  'material.trfUnmapped': 'Not mapped yet (needs alignment)',
  'material.trfDone': 'Transferred to SAP.',
  'material.trfError': 'Transfer failed.',
  'material.trfPreviewError': 'Preview could not be loaded.',
  'material.trfTargetSap': 'This environment writes to SAP (BAPI_MATERIAL_SAVEDATA via the adapter). “Check in SAP” calls the BAPI and rolls back – nothing is created; “Transfer to SAP” creates the material.',
  'material.trfTargetNone': 'Transfer to SAP is switched off in this environment (MATERIAL_SAP_TARGET=none).',
  'material.trfCheck': 'Check in SAP',
  'material.trfCheckOk': 'SAP check passed – nothing written.',
  'material.trfCheckFail': 'SAP rejects the material – see messages.',
  'material.trfMessages': 'SAP messages',
  'material.trfMatnr': 'Material number',
  'material.trfNumberInternal': 'assigned internally',
  'material.trfNumberExternal': 'given externally',
  'material.trfViews': 'Views',
  'material.delete': 'Delete',
  'material.emptyList': 'No materials created yet.',
  'material.listError': 'Material list could not be loaded.',
  'material.loadError': 'Material could not be loaded.',
  'material.mirrorSuccess': 'Material mirrored into the catalog.',
  'material.mirrorError': 'Mirroring failed.',
  'material.confirmDelete': 'Really delete this material?',
  'material.deleteSuccess': 'Material deleted.',
  'material.deleteError': 'Deletion failed.',
  // Change path (update transferred materials in SAP)
  'material.updTitle': 'Update in SAP',
  'material.updConfirm': 'Update in SAP',
  'material.updCheck': 'Check changes in SAP',
  'material.updChanges': 'Changes versus the last SAP state',
  'material.updNoChanges': 'No changes versus the last SAP state – nothing to send.',
  'material.updDone': 'Material updated in SAP.',
  'material.updCheckOk': 'SAP check passed – change not written.',
  'material.updCheckFail': 'SAP rejects the change – see messages.',
  'material.updTargetSap': 'This environment writes to SAP. "Check changes in SAP" calls the BAPI and rolls back (no number is consumed); "Update in SAP" changes the existing material – only the changed fields.',
  'material.updNoBaseline': 'No baseline: no successful transfer is recorded for this material.',
  'material.trfChangeFrom': 'before',
  'material.trfChangeTo': 'new',
  'material.trfEmpty': '(empty)',
  // Alternative units of measure
  'material.units': 'Alternative units of measure',
  'material.addUnit': 'Add unit',
  'material.unitAlt': 'Unit',
  'material.unitNum': 'Numerator',
  'material.unitDen': 'Denominator',
  'material.unitEan': 'EAN (optional)',
  'material.unitHint': 'Conversion to the base unit: 1 {alt} = {num}/{den} {base}',
  // "Load from SAP": source
  'material.sapSourceLive': 'Source: SAP live via the adapter',
  'material.sapSourceMirror': 'Source: local mirror (no live access in this environment)',
  'material.sapSearchHint': 'Enter a search term – description (several words allowed) or material number.',
  'material.sapDeleted': 'flagged for deletion',
};

export default material;
